
import {Options, Vue} from 'vue-class-component';
import './../less/awards.less'
import Gallery from "@/components/Gallery.vue";
import RegistrationForm from './RegistrationForm.vue';
import Logo from "@/components/Logo.vue";
import axios from "axios";

@Options({
    components: {
        Gallery,
        Logo,
        RegistrationForm
    },
})
export default class AwardsPage extends Vue {
    isOpenMenu = false
    awards = []

    menuToggle() {
        this.isOpenMenu = !this.isOpenMenu
    }

    mounted() {
        this.getAwardsData()
        document.title = 'HBA - Soron következő díjátadóink'
    }

    getAwardsData() {
        axios.get('/api/v1/awards?sort_by=order&sort_dir=asc').then((data) => {
            if (data?.data?.data.length > 0) {
                this.awards = data.data.data
            }
        })
    }
}
